export default "__VITE_ASSET__f72472d8__"